module.exports = __webpack_public_path__ + "assets/normal/images/progress-pending.2da2a69a.png";